import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// ~~~~~ Servicios ~~~~~ //
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { ServiciosGenerales } from './main/content/Servicios/ServiciosGenerales.service';


// ~~~~~ Modulos ~~~~~ //
import { FuseSampleModule } from './main/content/sample/sample.module';
import { PrefijoModule } from './main/content/Prefijo/Prefijo.module';
import { NegocioModule } from './main/content/Negocio/Negocio.module';
import { TerceroModule } from './main/content/Tercero/Tercero.module';
import { FacturaModule } from './main/content/EnviarFacturas/Factura.module';
import { CreraFacturaModule } from './main/content/CrearFactura/CrearFactura.module';
import { LoginModule } from './main/content/Login/Login.module';
import { NotasModule } from './main/content/Notas/Notas.module';
import { Base64UploadModule } from './main/content/CargueTercerosMasivos/Base64Upload.module';
import { CargueArchivosGenericoModule } from './main/content/CargueArchivosGenerico/CargueArchivosGenerico.module';
import { ReimpresionFacturaModule } from './main/content/ReimpresionFactura/ReimpresionFactura.module';
import { UsuariosModule } from './main/content/Usuarios/Usuarios.module';
import { ReportesModule } from './main/content/Reportes/Reportes.module';
import { ReporteFacturacionModule } from './main/content/ReporteFacturacion/ReporteFacturacion.module';
import { ReportesInmobiliariasModule } from './main/content/ReportesInmobiliarias/ReportesInmobiliarias.module';
import { EstadosDeFacturasYNotasDianModule } from './main/content/EstadosDeFacturasYNotasDian/EstadosDeFacturasYNotasDian.module';
import { ReportesInterfazContableModule } from './main/content/InterfazContable/ReportesInterfazContable.module';
import { CargueArchivoBaseBeneficiariosModule } from './main/content/CargueArchivoBaseBeneficiarios/CargueArchivoBaseBeneficiarios.module';
import { DistribucionRendimientosModule } from './main/content/DistribucionRendimientos/DistribucionRendimientos.module';
import { ReversarDistribucionModule } from './main/content/ReversarDistribucion/ReversarDistribucion.module';
import { CargueArchivoPagosModule } from './main/content/CargueArchivoPagos/CargueArchivoPagos.module';
import { CierreMesModule } from './main/content/CierreMes/CierreMes.module';
import { DisminucionBaseRendimientosModule } from './main/content/DisminucionBaseRendimientos/DisminucionBaseRendimientos.module';
import { ReversarCierreMesModule } from './main/content/ReversarCierreMes/ReversarCierreMes.module';
import { CargueArchivoControlPagosModule } from './main/content/CargueArchivoControlPagos/CargueArchivoControlPagos.module';
import { PagosModule } from './main/content/Pagos/Pagos.module';
import { IngresoRecursosParcialModule } from './main/content/IngresoRecursosParcial/IngresoRecursosParcial.module';
import { ActualizarInformacionBeneficiariosModule } from './main/content/ActualizarInformacionBeneficiarios/ActualizarInformacionBeneficiarios.module';
import { InhabilitarBeneficiarioModule } from './main/content/InhabilitarBeneficiario/InhabilitarBeneficiario.module';
import { CargueReprogramacionModule } from './main/content/CargueReprogramacion/CargueReprogramacion.module';
import { BasicosModule } from './main/content/Basicos/Basicos.module';
import { LiquidacionesModule } from './main/content/Liquidaciones/Liquidaciones.module';
import { ContabilidadModule } from './main/content/Contabilidad/Contabilidad.module';
import { MallaSeguridadModule } from './main/content/MallaSeguridad/MallaSeguridad.module';
import { GenerarInterfazModule } from './main/content/GenerarInterfaz/GenerarInterfaz.module';
import { ConceptoModule } from './main/content/CrearConcepto/Concepto.module';
import { AdministracionUsuariosModule } from './main/content/AdministracionUsuarios/AdministracionUsuarios.module';
import { CargueMasivoFacturasModule } from './main/content/CargueFacturasMasivos/CargueFacturas.module';
import { HabilitarEnvioFacturasModule } from './main/content/HabilitarEnvioFacturas/HabilitarEnvioFacturas.module';
import { ResolucionModule } from './main/content/Resoluciones/Resolucion.module';
import { SaldoIndemnizacionesModule } from './main/content/Saldo Indemnizaciones/SaldoIndemnizaciones.module';
import { ReporteTotalSaldoCapitalAdministradoModule } from './main/content/ReporteTotalSaldoCapitalAdministrado/ReporteTotalSaldoCapitalAdministrado.module';
import { TercerosVigentesCapitalFechaCorteModule } from './main/content/TercerosVigentesCapitalFechaCorte/TercerosVigentesCapitalFechaCorte.module';
import { TercerosVigentesCapitalAcumuladoModule } from './main/content/TercerosVigentesCapitalAcumulado/TercerosVigentesCapitalAcumulado.module';



import { EscrituraModule } from './main/content/CrearEscritura/Escritura.module';
import { asignarPDFEscrituraModule } from './main/content/CrearEscritura/asignarPDFEscritura.module';
import { asignarPDFCostosModule } from './main/content/CrearEscritura/asignarPDFCostos.module';
import { ConsultaDocumentacionInmueblesModule } from './main/content/ConsultaDocumentacionInmuebles/ConsultaDocumentacionInmuebles.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DialogoConfirmacionComponent } from './main/content/DialogConfirmacion/dialogo-confirmacion.component';
import { RoleGuardService as RoleGuard } from './main/content/Seguridad/role-guard.service';
import { AuthService } from './main/content/Seguridad/auth.service';
import { ConfirmarEliminacionModule } from './main/content/Dialog/ConfirmarEliminacion.module';
import { ConfirmarEliminacionService } from './main/content/Dialog/ConfirmarEliminacionService';
import { FacturacionElectronicaConsultarLogModule } from './main/content/FacturacionElectronicaConsultarLog/FacturacionElectronicaConsultarLog.module';
import { FacturacionElectronicaConsultarPdfModule } from './main/content/FacturacionElectronicaDescargarImagen/FacturacionElectronicaConsultarPdf.module';
import { FacturacionElectronicaConsultarEstadoFacturaModule } from './main/content/FacturacionElectronicaConsultarEstadoFactura/ConsultarEstadoFactura.module';
import { FacturacionElectronicaReenviarFacturaModule } from './main/content/FacturacionElectronicaReenviarFactura/FacturacionElectronicaReenviarFactura.module';
import { CacheInterceptor } from './main/content/http-interceptors/CacheInterceptor';
import { ForgotPassword2Module } from './main/content/forgot-password-2/forgot-password-2.module';
import { ParametrizarParametrosModule } from './main/content/ParametrizarParametros/ParametrizarParametrosModule.module';
import { ControlEscrituraModule } from './main/content/ControlEscrituras/ControlEscrituras.module';
import { ControlEscrituraMasivaModule } from './main/content/ControlEscriturasMasiva/ControlEscriturasMasiva.module';
import { SolicitudNotasModule } from './main/content/SolicitudNotas/SolicitudNotas.module';
import { CargueReprogramacionDesvinculadosModule } from './main/content/CargueReprogramacionDesvinculados/CargueReprogramacionDesvinculados.module';
import {LegalizarEscriturasModule} from './main/content/LegalizacionEscrituras/LegalizarEscrituras.module'
import { ConsultarInterfazModule } from './main/content/ConsultarInterfaz/ConsultarInterfaz.module';
import { DescargarInterfazModule } from './main/content/DescargarInterfaz/DescargarInterfaz.module';


const appRoutes: Routes = [
    {
        path      : '**',
        redirectTo: 'login'
    },
    {
        path      : 'victimas',
        redirectTo: 'victimas'
    },
    {
        path      : 'dashboard',
        redirectTo: 'dashboard'
    },
    {
        path      : 'Prefijo',
        redirectTo: 'Prefijo'
    },
    {
        path      : 'Negocio',
        redirectTo: 'Negocio'
    },
    {
        path      : 'Tercero',
        redirectTo: 'Tercero'
    },
    {
        path      : 'Factura',
        redirectTo: 'Factura'
    },
    {
        path      : 'CrearFactura',
        redirectTo: 'CrearFactura'
    }
    ,
    {
        path      : 'Usuarios',
        redirectTo: 'Usuarios'
    },
    {
        path      : 'Reportes',
        redirectTo: 'Reportes'
    },
    {
        path      : 'GenerarInterfaz',
        redirectTo: 'GenerarInterfaz'
    },
    {
        path      : 'Concepto',
        redirectTo: 'Concepto'
    },
    {
        path      : 'CrearUsuario',
        redirectTo: 'CrearUsuario'
    },
    {
        path      : 'UsuarioIndex',
        redirectTo: 'UsuarioIndex'
    },
    {
        path      : 'CrearPerfil',
        redirectTo: 'CrearPerfil'
    },
    {
        path      : 'CargueMasivoFacturas',
        redirectTo: 'CargueMasivoFacturas'
    },
    {
        path      : 'HabilitarEnvioFacturas',
        redirectTo: 'HabilitarEnvioFacturas'
    },
    {
        path      : 'Resolucion',
        redirectTo: 'Resolucion'
    },{
        path      : 'ConsultarLog',
        redirectTo: 'ConsultarLog'
    },{
        path      : 'DescargarImagenDocumento',
        redirectTo: 'DescargarImagenDocumento'
    },{
        path      : 'ConsultarEstadoDocumento',
        redirectTo: 'ConsultarEstadoDocumento'
    },{
        path      : 'CargueArchivosGenerico',
        redirectTo: 'CargueArchivosGenerico'
    },{
        path      : 'ReenviarFactura',
        redirectTo: 'ReenviarFactura'
    },{
        path      : 'ReporteFacturacionElectronica',
        redirectTo: 'ReporteFacturacionElectronica'
    },{
        path      : 'cambiarPass',
        redirectTo: 'cambiarPass'
    },{
        path      : 'ParametrizarParametros',
        redirectTo: 'ParametrizarParametros'

    },
    {
        path      : 'CargueArchivoBaseBeneficiarios',
        redirectTo: 'CargueArchivoBaseBeneficiarios'
    },
    {
        path      : 'DistribucionRendimientos',
        redirectTo: 'DistribucionRendimientos'
    },
    {
        path      : 'CargueArchivoPagos',
        redirectTo: 'CargueArchivoPagos'
    },
    {
        path      : 'CierreMes',
        redirectTo: 'CierreMes'
   },
   {
       path      : 'CargueArchivoControlPagos',
       redirectTo: 'CargueArchivoControlPagos'
   },
  {
        path      : 'EstadosDeFacturasYNotasDianModule',
        redirectTo: 'EstadosDeFacturasYNotasDianModule'
  },
  {
        path      : 'Pagos',
        redirectTo: 'Pagos'
    },
    {
        path      : 'IngresoRecursosParcial',
        redirectTo: 'IngresoRecursosParcial'
      },
    
    {
        path      : 'Basicos',
        redirectTo: 'Basicos'
    } ,
    {
        path      : 'Liquidaciones',
        redirectTo: 'Liquidaciones'
    } ,
    {
        path      : 'Contabilidad',
        redirectTo: 'Contabilidad'
    },
    {
        path      : 'MallaSeguridad',
        redirectTo: 'MallaSeguridad'
    },
    {
        path      : 'SaldoIndemnizaciones',
        redirectTo: 'SaldoIndemnizaciones'
    },
    {
        path      : 'ReporteTotalSaldoCapitalAdministrado',
        redirectTo: 'ReporteTotalSaldoCapitalAdministrado'
    },
    {
        path      : 'ActualizarInformacionBeneficiarios',
        redirectTo: 'ActualizarInformacionBeneficiarios'
    },{
        path      : 'InhabilitarBeneficiario',
        redirectTo: 'InhabilitarBeneficiario'

    },{
        path      : 'DisminucionBaseRendimientosModule',
        redirectTo: 'DisminucionBaseRendimientosModule'
        

    },{
        path      : 'Escritura',
        redirectTo: 'Escritura'
    }
    ,{
        path      : 'ReportesInmobiliaria',
        redirectTo: 'ReportesInmobiliaria'
    },
    {
        path      : 'ControlEscrituras',
        redirectTo: 'ControlEscrituras'
    },
    {
        path      : 'ControlEscriturasMasiva',
        redirectTo: 'ControlEscriturasMasiva'
    },
    {
        path      : 'ConsultaDocumentacionInmuebles',
        redirectTo: 'ConsultaDocumentacionInmuebles'
    },
    {
        path      : 'ReportesInterfazContable',
        redirectTo: 'ReportesInterfazContable'
    },
    {
        path      : 'ReversarCierreMes',
        redirectTo: 'ReversarCierreMes'
    },{
        path      : 'ReversarDistribucion',
        redirectTo: 'ReversarDistribucion'
    },{
        path      : 'TercerosVigentesCapitalFechaCorte',
        redirectTo: 'TercerosVigentesCapitalFechaCorte'   
    },{
        path      : 'TercerosVigentesCapitalAcumulado',
        redirectTo: 'TercerosVigentesCapitalAcumulado'   
    },{
        path      : 'CargueReprogramacion',
        redirectTo: 'CargueReprogramacion'   
    },{
        path      : 'SolicitudNotas',
        redirectTo: 'SolicitudNotas'   
    }
    ,{
        path      : 'CargueReprogramacionDesvinculados',
        redirectTo: 'CargueReprogramacionDesvinculados'   
    },
    {
        path      : 'LegalizarEscritura',
        redirectTo: 'LegalizarEscritura'
    } ,
    {
        path      : 'ConsultarInterfaz',
        redirectTo: 'ConsultarInterfaz'
    } ,
    {
        path      : 'DescargarInterfaz',
        redirectTo: 'DescargarInterfaz'
    } 
];

@NgModule({
    declarations: [
        AppComponent,
        DialogoConfirmacionComponent,
    ],
    imports     : [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
        FuseMainModule,
        FuseSampleModule,
        LoginModule,
        PrefijoModule,
        NegocioModule,
        TerceroModule,
        FacturaModule,
        CreraFacturaModule,
        ControlEscrituraModule,
        ControlEscrituraMasivaModule, 
        NotasModule,
        Base64UploadModule,
        ReimpresionFacturaModule,
        ReportesInterfazContableModule,
        UsuariosModule,
        ReportesModule,
        ReportesInmobiliariasModule,
        GenerarInterfazModule,
        ConceptoModule,
        AdministracionUsuariosModule,
        CargueMasivoFacturasModule,
        HabilitarEnvioFacturasModule,
        ResolucionModule,
        ConfirmarEliminacionModule,
        FacturacionElectronicaConsultarLogModule,
        FacturacionElectronicaConsultarPdfModule,
        FacturacionElectronicaConsultarEstadoFacturaModule,
        CargueArchivosGenericoModule,
        FacturacionElectronicaReenviarFacturaModule,
        ReporteFacturacionModule,
        ForgotPassword2Module,
        ParametrizarParametrosModule,
        SaldoIndemnizacionesModule,
        ReporteTotalSaldoCapitalAdministradoModule,
        TercerosVigentesCapitalFechaCorteModule,
        TercerosVigentesCapitalAcumuladoModule,
        EscrituraModule,
        asignarPDFEscrituraModule,
        asignarPDFCostosModule,
        ConsultaDocumentacionInmueblesModule,
        CargueArchivoBaseBeneficiariosModule,
        DistribucionRendimientosModule,
        ReversarDistribucionModule,
        CargueArchivoPagosModule,
        CierreMesModule,
        ReversarCierreMesModule,
        DisminucionBaseRendimientosModule,
        CargueArchivoControlPagosModule,
        EstadosDeFacturasYNotasDianModule,
        PagosModule,
        BasicosModule,
        LiquidacionesModule,
        ContabilidadModule,
        MallaSeguridadModule,
        IngresoRecursosParcialModule,
        ActualizarInformacionBeneficiariosModule,
        InhabilitarBeneficiarioModule,
        MatDialogModule, // <--- Aquí
        BrowserAnimationsModule, // <--- Aquí
        MatButtonModule ,// <--- Aquí
        CargueReprogramacionModule,
        SolicitudNotasModule,
        CargueReprogramacionDesvinculadosModule,
        LegalizarEscriturasModule,
        SolicitudNotasModule,
        ConsultarInterfazModule,
        DescargarInterfazModule
    ],
    providers   : [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        ServiciosGenerales,
        RoleGuard,
        AuthService,
        ConfirmarEliminacionService,
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
    ],
    bootstrap   : [
        AppComponent

    ],
    entryComponents: [
        DialogoConfirmacionComponent// <--- Aquí
      ]
})

export class AppModule
{
}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/app.module.ts